<script setup>
defineProps({
  search: String,
  unitType: String,
  paymentStatus: String,
  unitTypeOptions: {
    type: Array,
    default: () => [],
  },
  paymentStatusOptions: {
    type: Array,
    default: () => [],
  },
});

defineEmits([
  "update:search",
  "update:unitType",
  "update:paymentStatus",
  "reset",
]);
</script>
<template>
  <div class="card border-0 shadow-sm rounded-4 mb-4">
    <div class="card-body p-4">
      <div class="row g-3 align-items-end">
        <div class="col-lg-5">
          <label class="form-label fw-semibold text-secondary">ค้นหา</label>
          <div class="input-group">
            <span class="input-group-text bg-white">
              <i class="bi bi-search"></i>
            </span>
            <input
              type="text"
              class="form-control"
              placeholder="ค้นหาจากรหัสยูนิต บ้านเลขที่ อาคาร หรือชื่อลูกบ้าน"
              :value="search"
              @input="$emit('update:search', $event.target.value)"
            />
          </div>
        </div>

        <div class="col-lg-3">
          <label class="form-label fw-semibold text-secondary"
            >ประเภทยูนิต</label
          >
          <select
            class="form-select"
            :value="unitType"
            @change="$emit('update:unitType', $event.target.value)"
          >
            <option
              v-for="option in unitTypeOptions"
              :key="option.value"
              :value="option.value"
            >
              {{ option.label }}
            </option>
          </select>
        </div>

        <div class="col-lg-3">
          <label class="form-label fw-semibold text-secondary"
            >สถานะการชำระ</label
          >
          <select
            class="form-select"
            :value="paymentStatus"
            @change="$emit('update:paymentStatus', $event.target.value)"
          >
            <option
              v-for="option in paymentStatusOptions"
              :key="option.value"
              :value="option.value"
            >
              {{ option.label }}
            </option>
          </select>
        </div>

        <div class="col-lg-1">
          <button
            type="button"
            class="btn btn-light border w-100 rounded-3"
            @click="$emit('reset')"
            title="ล้างตัวกรอง"
          >
            <i class="bi bi-arrow-clockwise"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
